import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContasService from '../../services/prest-contas';
import Documento from './documento';

const ListarDocumentos = () => {

    const [documentos, setDocumentos] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchDocumentos() {
        const response = await ContasService.cat({categoria: "Prestação de Contas Anual"});
        if (response.data.length >= 1) {
            setDocumentos(response.data)
            setVazio(false)
        } else {
            setDocumentos([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchDocumentos();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setDocumentos={setDocumentos}
                    setVazio={setVazio}
                    fetchDocumentos={fetchDocumentos}
                    documentos={documentos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h4>Prestações de Contas Anuais</h4>
                    <Row xs={1}>
                        {documentos.map((doc, index) =>
                            <Documento
                                doc={doc}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarDocumentos;